/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type StartUpgradeTierRequestDTO = {
    tierType?: StartUpgradeTierRequestDTO.tierType;
};

export namespace StartUpgradeTierRequestDTO {

    export enum tierType {
        BRONZE = 'BRONZE',
        SILVER = 'SILVER',
        GOLD = 'GOLD',
        PLATINUM = 'PLATINUM',
    }


}

